import { render, staticRenderFns } from "./scrollToTop.vue?vue&type=template&id=f908e280&scoped=true&"
import script from "./scrollToTop.vue?vue&type=script&lang=ts&"
export * from "./scrollToTop.vue?vue&type=script&lang=ts&"
import style0 from "./scrollToTop.vue?vue&type=style&index=0&id=f908e280&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f908e280",
  null
  
)

export default component.exports